import Vue from 'vue';
import App from './App.vue';
import router from './router';
import firebase from 'firebase';
import { firestorePlugin } from 'vuefire';

Vue.config.productionTip = false;

let app = '';

Vue.use(firestorePlugin);
var firebaseConfig = {
	apiKey: 'AIzaSyDJ1lI-kGEnQqIjpYUwiUtJMEgItQLQOqg',
	authDomain: 'gettrakyak.firebaseapp.com',
	databaseURL: 'https://gettrakyak.firebaseio.com',
	projectId: 'gettrakyak',
	storageBucket: 'gettrakyak.appspot.com',
	messagingSenderId: '152358312936',
	appId: '1:152358312936:web:db5dbefee78a119812625d'
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

firebase.auth().onAuthStateChanged(() => {
	if (!app) {
		app = new Vue({
			router,
			render: (h) => h(App)
		}).$mount('#app');
	}
});
